import { ResumeSGChargeConstant } from "presentation/constant/ResumeSGCharge/ResumeSGChargeConstant";
import { useResumeSGChargeVM } from "presentation/hook/ResumeSGCharge/useResumeSGChargeVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useResumeSGChargeTracked } from "presentation/store/ResumeSGCharge/ResumeSGChargeProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const ResumeSGChargeTitleBar: React.FC = () => {
    const [resumeSGChargeState] = useResumeSGChargeTracked();
    const resumeSGChargeVM = useResumeSGChargeVM();
    const [isLoading, setIsLoading] = useState(false);
    const { selectedRows, searchCriteria } = resumeSGChargeState;
    const messageBarVM = useMessageBarVM();

    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;

    const handleSearch = useCallback(async () => {
        resumeSGChargeVM.onSearchClick();
    }, [resumeSGChargeVM]);


    const handleResumeClick = useCallback(async () => {
        if (selectedRows.length === 0) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        setIsLoading(true);

        const dataObjMap = selectedRows.reduce((acc, item) => {
            const key = item.id;
            const value = item.dataReferenceType;
            acc[key] = value;
            return acc;
        }, {} as { [key: number]: string });

        resumeSGChargeVM.onResume(dataObjMap).then(async (data) => {
            if (data && data.success) {
                messageBarVM.showSuccess("Resume SG Charge successfully.");
                resumeSGChargeVM.onSearch(searchCriteria).then((data) => {
                    setIsLoading(false);
                })
            } else {
                setIsLoading(false);
                messageBarVM.showError(data.data);
            }
        }).catch(error => {
            setIsLoading(false);
        });

    }, [messageBarVM, resumeSGChargeVM, searchCriteria, selectedRows]);


    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{ResumeSGChargeConstant.TITLE}</HeaderTitle>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
            {allowUpdate && <><div className="add-seperator" />
                <HPHButton disabled={selectedRows.length === 0} label={'Resume'} size={'Small'} theme={'Primary'} onClick={handleResumeClick} />
            </>}
        </StyledAction>
        {resumeSGChargeState.forceRefresh && <></>}
    </Sidebarheader>
}

export default memo(ResumeSGChargeTitleBar);